import { render, staticRenderFns } from "./ClassAttendance.vue?vue&type=template&id=8f7733e6&scoped=true"
import script from "./ClassAttendance.vue?vue&type=script&lang=js"
export * from "./ClassAttendance.vue?vue&type=script&lang=js"
import style0 from "./ClassAttendance.vue?vue&type=style&index=0&id=8f7733e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7733e6",
  null
  
)

export default component.exports